class SizeGroupPicker extends HTMLElement {
  static defaultedSections = new WeakSet();

  connectedCallback() {
    this.tabButtons = Array.from(this.querySelectorAll('[data-size-group-tab]'));
    this.tabButtons.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        this.showGroup(tab.dataset.sizeGroupTab);
      });
    });

    this.addEventListener('change', () => this.updateLabel());
    this.addEventListener('click', (event) => {
      const label = event.target.closest('label');
      if (!label || !this.contains(label)) return;

      const inputId = label.getAttribute('for');
      const input = inputId ? this.querySelector(`#${CSS.escape(inputId)}`) : null;
      if (!input || input.disabled) return;

      event.preventDefault();
      if (input.checked) {
        this.updateLabel();
        return;
      }

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const productInfo = this.closest('product-info');
    const urlHasVariant = new URLSearchParams(window.location.search).has('variant');
    const shouldDefaultAdult =
      this.dataset.forceDefault === 'true' &&
      !urlHasVariant &&
      productInfo &&
      !SizeGroupPicker.defaultedSections.has(productInfo);

    let activeGroup = this.dataset.activeGroup || 'adult';

    if (shouldDefaultAdult) {
      SizeGroupPicker.defaultedSections.add(productInfo);
      const adultInput =
        this.querySelector('[data-size-group="adult"] input:not(.disabled):not(:disabled)') ||
        this.querySelector('[data-size-group="adult"] input');

      if (adultInput) {
        activeGroup = 'adult';
        if (!adultInput.checked) adultInput.checked = true;
        adultInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      const selectedInput = this.querySelector('input[type="radio"]:checked');
      const selectedGroup = selectedInput?.closest('[data-size-group]')?.dataset.sizeGroup;
      if (selectedGroup) activeGroup = selectedGroup;
    }

    this.showGroup(activeGroup);
    this.updateLabel();
  }

  groupLabel(group) {
    const labels = {
      infant: this.dataset.labelInfant,
      youth: this.dataset.labelYouth,
      adult: this.dataset.labelAdult,
    };
    return labels[group] || group;
  }

  updateLabel() {
    const selected = this.querySelector('input[type="radio"]:checked');
    const groupEl = this.querySelector('[data-selected-group]');
    const valueEl = this.querySelector('[data-selected-value]');
    if (!selected || !groupEl || !valueEl) return;

    const group = selected.closest('[data-size-group]')?.dataset.sizeGroup;
    if (group) groupEl.textContent = this.groupLabel(group);
    valueEl.textContent = selected.value;
  }

  showGroup(group) {
    this.querySelectorAll('[data-size-group]').forEach((option) => {
      option.hidden = option.dataset.sizeGroup !== group;
    });

    this.tabButtons.forEach((tab) => {
      const selected = tab.dataset.sizeGroupTab === group;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
  }
}

if (!customElements.get('size-group-picker')) {
  customElements.define('size-group-picker', SizeGroupPicker);
}
